import React from 'react';
import { Route } from 'react-router-dom';
import './app.scss';
import Activate from 'app/modules/account/activate/activate';
import PasswordResetInit from 'app/modules/account/password-reset/init/password-reset-init';
import PasswordResetFinish from 'app/modules/account/password-reset/finish/password-reset-finish';
import Home from 'app/modules/home/home';
import EntitiesRoutes from 'app/entities/routes';
import PrivateRoute from 'app/shared/auth/private-route';
import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';
import PageNotFound from 'app/shared/error/page-not-found';
import { AUTHORITIES } from 'app/config/constants';
import CaseChangeConfirmationWrapper from 'app/shared/modal/case-change-confirmation-wrapper';
import ErrorBoundary from 'app/shared/error/error-boundary';
import Header from 'app/shared/layout/header/header';
import { useAppSelector } from 'app/config/store';
import Footer from 'app/shared/layout/footer/footer';
import Cases from 'app/edozvola/cases';
import CaseSubmission from 'app/edozvola/case-submission';
import CurrentRegulations from 'app/edozvola/current-regulations';
import Account from 'app/modules/account';
import MainSidebarContextWrapper from 'app/shared/layout/main-sidebar/main-sidebar-context';
import CaseFileInspection from './edozvola/case-file-inspection/case-file-inspection';
import NoticeBoard from 'app/modules/notice-board/notice-board';
import LogoutDeniedRedirect from 'app/modules/logout/logout-denied-redirect';
import { IPS_REGISTAR } from 'app/shared/enumeration/enums';
import MyCases from "app/modules/pub-web-cases/my-cases";
import ParticipantCases from "app/modules/pub-web-cases/participant-cases";
import CasesPreviewRoutes from 'app/edozvola/cases/case-preview';
import CustomLogin from 'app/shared/custom-login/custom-login';
import DocumentPreview from 'app/edozvola/document-preview/document-preview';
import NotificationOverview from "app/modules/notifications/notification-overview";
import AdministrativeUnitOverview from "app/edozvola/administrative-unit-overview/administrative-unit-overview";
import PublicAuthorityOverview from 'app/edozvola/public-authority-overview/public-authority-overview';
import ChamberMemberOverview from 'app/edozvola/chamber-member-overview/chamber-member-overview';

const AppRoutes = () => {
  const currentLocale = useAppSelector(state => state.locale.currentLocale);
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const ribbonEnv = useAppSelector(state => state.applicationProfile.ribbonEnv);
  const isInProduction = useAppSelector(state => state.applicationProfile.inProduction);
  const isOpenAPIEnabled = useAppSelector(state => state.applicationProfile.isOpenAPIEnabled);
  const userAuthorities = useAppSelector(state => state.authentication.account.authorities);
  const hasAnonymousRole = userAuthorities && userAuthorities.includes(AUTHORITIES.NEPRIJAVLJENI);
  const ipsRegistar = useAppSelector(state => state.authentication.account.szIpsRegistar);
  const personLoggedInNotIpsRegistarRBOType = Number(ipsRegistar) !== IPS_REGISTAR.RBO;

  return (
    <div id="content-wrapper" className="view-routes">
      <ErrorBoundary>
        <Header
          isAuthenticated={isAuthenticated}
          currentLocale={currentLocale}
          ribbonEnv={ribbonEnv}
          isInProduction={isInProduction}
          isOpenAPIEnabled={isOpenAPIEnabled}
          hasAnonymousRole={hasAnonymousRole}
        />
      </ErrorBoundary>
      <main>
        {isAuthenticated && (
          <ErrorBoundaryRoutes>
            <Route
              index
              element={
                <MainSidebarContextWrapper
                  isAuthenticated={isAuthenticated}
                  hasAnonymousRole={hasAnonymousRole}
                  shouldShowCreateCaseTab={personLoggedInNotIpsRegistarRBOType}
                >
                  <Home />
                </MainSidebarContextWrapper>
              }
            />
            <Route path="document-preview/:documentType/:uuid" element={<DocumentPreview />} />
            <Route path="custom-login/*" element={<CustomLogin isAuthenticated={isAuthenticated} hasAnonymousRole={hasAnonymousRole} />} />
            <Route
              path="cases/*"
              element={
                <MainSidebarContextWrapper
                  isAuthenticated={isAuthenticated}
                  hasAnonymousRole={hasAnonymousRole}
                  showOnlyOnRoute={'cases'}
                  shouldShowCreateCaseTab={personLoggedInNotIpsRegistarRBOType}
                >
                  <Cases />
                </MainSidebarContextWrapper>
              }
            ></Route>
            <Route
              path="cases-preview/*"
              element={
                <MainSidebarContextWrapper
                  isAuthenticated={isAuthenticated}
                  hasAnonymousRole={hasAnonymousRole}
                  showOnlyOnRoute={'cases-preview'}
                  shouldShowCreateCaseTab={false}
                >
                  <CasesPreviewRoutes />
                </MainSidebarContextWrapper>
              }
            ></Route>
            <Route path="logout-denied-redirect" element={<LogoutDeniedRedirect />} />

            {personLoggedInNotIpsRegistarRBOType && (
              <>
                <Route
                  path="case-submission/*"
                  element={
                    <MainSidebarContextWrapper
                      isAuthenticated={isAuthenticated}
                      hasAnonymousRole={hasAnonymousRole}
                      shouldShowCreateCaseTab={personLoggedInNotIpsRegistarRBOType}
                    >
                      <CaseSubmission />
                    </MainSidebarContextWrapper>
                  }
                />
                <Route
                  path="case-submission/case/*"
                  element={
                    <MainSidebarContextWrapper
                      isAuthenticated={isAuthenticated}
                      hasAnonymousRole={hasAnonymousRole}
                      showOnlyOnRoute={'case'}
                      shouldShowCreateCaseTab={personLoggedInNotIpsRegistarRBOType}
                    >
                      <Cases />
                    </MainSidebarContextWrapper>
                  }
                />
              </>
            )}

            <Route
              path="current-regulations/*"
              element={
                <MainSidebarContextWrapper
                  isAuthenticated={isAuthenticated}
                  hasAnonymousRole={hasAnonymousRole}
                  shouldShowCreateCaseTab={personLoggedInNotIpsRegistarRBOType}
                >
                  <CurrentRegulations />
                </MainSidebarContextWrapper>
              }
            />
            <Route
              path="case-file-inspection/*"
              element={
                <MainSidebarContextWrapper
                  isAuthenticated={isAuthenticated}
                  hasAnonymousRole={hasAnonymousRole}
                  shouldShowCreateCaseTab={personLoggedInNotIpsRegistarRBOType}
                >
                  <CaseFileInspection />
                </MainSidebarContextWrapper>
              }
            />
            <Route
              path="case-file-inspection/cases-preview/*"
              element={
                <MainSidebarContextWrapper
                  isAuthenticated={isAuthenticated}
                  hasAnonymousRole={hasAnonymousRole}
                  showOnlyOnRoute={'cases-preview'}
                  shouldShowCreateCaseTab={false}
                >
                  <CasesPreviewRoutes />
                </MainSidebarContextWrapper>
              }
            />
            <Route
              path="notice-board/*"
              element={
                <MainSidebarContextWrapper
                  isAuthenticated={isAuthenticated}
                  hasAnonymousRole={hasAnonymousRole}
                  shouldShowCreateCaseTab={personLoggedInNotIpsRegistarRBOType}
                >
                  <NoticeBoard />
                </MainSidebarContextWrapper>
              }
            />
            <Route
              path="notifications"
              element={
                <MainSidebarContextWrapper
                  isAuthenticated={isAuthenticated}
                  hasAnonymousRole={hasAnonymousRole}
                  shouldShowCreateCaseTab={personLoggedInNotIpsRegistarRBOType}
                >
                  <NotificationOverview />
                </MainSidebarContextWrapper>
              }
            />
            <Route
              path="administrative-unit-overview"
              element={
                <MainSidebarContextWrapper
                  isAuthenticated={isAuthenticated}
                  hasAnonymousRole={hasAnonymousRole}
                  shouldShowCreateCaseTab={personLoggedInNotIpsRegistarRBOType}
                >
                  <AdministrativeUnitOverview />
                </MainSidebarContextWrapper>
              }
            />
            <Route
              path="public-authority-overview"
              element={
                <MainSidebarContextWrapper
                  isAuthenticated={isAuthenticated}
                  hasAnonymousRole={hasAnonymousRole}
                  shouldShowCreateCaseTab={personLoggedInNotIpsRegistarRBOType}
                >
                  <PublicAuthorityOverview />
                </MainSidebarContextWrapper>
              }
            />
            <Route
              path="chamber-member-overview"
              element={
                <MainSidebarContextWrapper
                  isAuthenticated={isAuthenticated}
                  hasAnonymousRole={hasAnonymousRole}
                  shouldShowCreateCaseTab={personLoggedInNotIpsRegistarRBOType}
                >
                  <ChamberMemberOverview />
                </MainSidebarContextWrapper>
              }
            />
            <Route path="account">
              <Route
                path="*"
                element={
                  <PrivateRoute>
                    <Account />
                  </PrivateRoute>
                }
              />
              <Route path="activate" element={<Activate />} />
              <Route path="reset">
                <Route path="request" element={<PasswordResetInit />} />
                <Route path="finish" element={<PasswordResetFinish />} />
              </Route>
            </Route>
            <Route
              path="my-cases"
              element={
                <MainSidebarContextWrapper
                  isAuthenticated={isAuthenticated}
                  hasAnonymousRole={hasAnonymousRole}
                  shouldShowCreateCaseTab={personLoggedInNotIpsRegistarRBOType}
                >
                  <PrivateRoute hasAnyAuthorities={[AUTHORITIES.EGRADANIN]}>
                    <MyCases />
                  </PrivateRoute>
                </MainSidebarContextWrapper>
              }
            ></Route>
            <Route
              path="participat-cases"
              element={
                <MainSidebarContextWrapper
                  isAuthenticated={isAuthenticated}
                  hasAnonymousRole={hasAnonymousRole}
                  shouldShowCreateCaseTab={personLoggedInNotIpsRegistarRBOType}
                >
                  <PrivateRoute hasAnyAuthorities={[AUTHORITIES.EGRADANIN]}>
                    <ParticipantCases />
                  </PrivateRoute>
                </MainSidebarContextWrapper>
              }
            ></Route>
            <Route
              path="*"
              element={
                <PrivateRoute hasAnyAuthorities={[AUTHORITIES.EGRADANIN]}>
                  <EntitiesRoutes />
                </PrivateRoute>
              }
            />
            <Route path="*" element={<PageNotFound />} />
          </ErrorBoundaryRoutes>
        )}
      </main>
      <Footer />

      <CaseChangeConfirmationWrapper />
    </div>
  );
};

export default AppRoutes;
